import { TabPanel } from '@/components';
import { useTranslation } from 'react-i18next';
import { HomeBaselinePanel } from './HomeBaselinePanel';

interface Props {
  homeId: string;
}

export function HomeBaselineTabPanel(props: Props) {
  const { homeId } = props;
  const { t } = useTranslation();

  return (
    <TabPanel>
      <TabPanel.Title>{t('homes.baseline.title')}</TabPanel.Title>
      <TabPanel.Body>
        <HomeBaselinePanel homeId={homeId} />
      </TabPanel.Body>
    </TabPanel>
  );
}
